    <p><a queryParamsHandling="merge" routerLink="/support/end-of-life-eol-policy-statement">End of Life (EOL)
        Statement</a> for {{ title }}:</p>
    <table class="table table-primary w-auto">
      <tr>
        <td>EOL announced:</td>
        <td>{{ eol }}</td>
      </tr>
      <tr>
        <td>Last Time Buy:</td>
        <td>{{ lastbuy }}</td>
      </tr>
      <tr>
        <td>Last Shipment:</td>
        <td>{{ lastship }}</td>
      </tr>
      <tr *ngIf="replacements">
        <td>Suitable Replacement(s):</td>
        <td>
          <a *ngFor="let product of replacelist; let last = last" class="bg-transparent p-0" queryParamsHandling="merge"
            [routerLink]="product.link">{{ product.title }}<span *ngIf="!last">, </span>
          </a>
        </td>
      </tr>
    </table>
